import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import rehypeStringify from "rehype-stringify";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import { unified } from "unified";

const processor = unified()
	.use(remarkParse)
	.use(remarkRehype)
	.use(rehypeSanitize, defaultSchema)
	.use(rehypeStringify);

export function renderMarkdown(md: string): string {
	const result = processor.processSync(md);
	return String(result);
}
